export default "__VITE_ASSET__VAR$FVOZ__"